module.exports = __webpack_public_path__ + "img/logo.bd39c1fa.png";